export default "__VITE_ASSET__74fe0ce0__"